import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { saveAccountId, saveAllAccounts, useAuth, useLazyGetPersonAccessesQuery } from '@ibk/shared-auth';
import { setSelectedAccountId, useAppDispatch, useGetProductRelationShips } from '@ibk/shared-config';
import { maskEmail, maskPhone, saveLastAccessedCompany } from '@ibk/shared-utils';
import { getLoginDestination } from '../Bpo/bpoSession';
export function useTwoFactorVerify(state) {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { validateToken, sendToken, loading: authLoading, error: authError } = useAuth();
    const { saveBillingProduct } = useGetProductRelationShips();
    const [getPersonAccesses, { isLoading: companiesLoading }] = useLazyGetPersonAccessesQuery();
    const [localError, setLocalError] = useState(null);
    const method = state?.method || 'phone';
    const getMaskedRecipient = () => {
        if (!state?.maskedRecipient) {
            return method === 'phone' ? '(**) *****-****' : '********@*mail.com';
        }
        return method === 'phone' ? maskPhone(state.maskedRecipient) : maskEmail(state.maskedRecipient);
    };
    const maskedRecipient = getMaskedRecipient();
    useEffect(() => {
        const hasRequiredData = state?.method && state?.maskedRecipient;
        if (!hasRequiredData) {
            navigate('/two-factor-select', { replace: true });
        }
    }, [state, navigate]);
    const handleContinue = async (token) => {
        setLocalError(null);
        let isTokenValid = false;
        try {
            isTokenValid = await validateToken(token);
        }
        catch (err) {
            setLocalError('Erro ao validar token. Tente novamente.');
            return;
        }
        if (!isTokenValid) {
            setLocalError('Token inválido. Verifique o código e tente novamente.');
            return;
        }
        try {
            const response = await getPersonAccesses().unwrap();
            const companies = response?.result || [];
            if (getLoginDestination() === '/bpo/clientes') {
                saveAllAccounts(companies);
                navigate('/bpo/clientes', { replace: true });
                return;
            }
            if (companies.length === 1) {
                const singleCompany = companies[0];
                const companyId = singleCompany.targetId;
                dispatch(setSelectedAccountId(companyId));
                saveAccountId(companies, companyId);
                saveAllAccounts(companies);
                await saveBillingProduct(companyId);
                saveLastAccessedCompany(companyId);
                navigate('/home', { replace: true });
                return;
            }
            navigate('/company-selection', {
                state: { from: 'two-factor-verify' },
                replace: true,
            });
        }
        catch {
            if (getLoginDestination() === '/bpo/clientes') {
                setLocalError('Não foi possível carregar as empresas. Tente novamente na carteira BPO.');
                navigate('/bpo/clientes', { replace: true });
                return;
            }
            navigate('/company-selection', {
                state: { from: 'two-factor-verify' },
                replace: true,
            });
        }
    };
    const handleResend = async () => {
        setLocalError(null);
        try {
            await sendToken(method);
        }
        catch (err) {
            setLocalError('Erro ao reenviar token. Tente novamente.');
        }
    };
    const handleBack = () => {
        if (!authLoading && !companiesLoading) {
            navigate('/two-factor-select', { replace: true });
        }
    };
    const displayError = localError || authError;
    return {
        maskedRecipient,
        method,
        disabled: authLoading || companiesLoading,
        error: displayError,
        onBack: handleBack,
        onContinue: handleContinue,
        onResend: handleResend,
    };
}
